import usePrivateAxios from '@/common/api/usePrivateAxios'
import {
  MaintenanceForwardingData,
  MaintenanceForwardingResponse,
} from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/types/maintenanceForwarding.type'
import { UseQueryResult, useQuery } from '@tanstack/react-query'

type UseMaintenanceForwarding = (forwardingId: string | undefined) => UseQueryResult<MaintenanceForwardingData, unknown>

export const useMaintenanceForwarding: UseMaintenanceForwarding = (forwardingId) => {
  const privateAxios = usePrivateAxios()

  return useQuery<MaintenanceForwardingResponse, unknown, MaintenanceForwardingData>({
    enabled: !!forwardingId,
    queryKey: ['maintenanceForwarding', forwardingId],
    queryFn: () => privateAxios.get(`/maintenance/forwardings/${forwardingId}`),
    select: (data) => data?.data?.data,
  })
}
